var ContentDto = (function () {
    function ContentDto(body, id, name, title) {
        this.body = body;
        this.id = id;
        this.name = name;
        this.title = title;
    }
    ContentDto.fromOcapi = function (ocapiResp) {
        return new ContentDto(ocapiResp.c_body, ocapiResp.id, ocapiResp.name, ocapiResp.title);
    };
    return ContentDto;
}());
export { ContentDto };
//# sourceMappingURL=ContentDto.js.map